import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../ui/shadcn-ui/card";
import { useNavigate } from "react-router-dom";
import { useNotificationContext } from "../../../Contexts/NotificationContext";


const NotificationList: React.FC = () => {
    const { notifications, markAsReadOnServer } = useNotificationContext(); // Add markAsReadOnServer
    const navigate = useNavigate();

    return (
        <Card onClick={(e) => e.stopPropagation()} 
        style={{
            maxHeight: '300px', 
            overflowY: 'auto',  
          }}
        >
            <CardHeader>
                <CardTitle>NOTIFICATIONS</CardTitle>
            </CardHeader>
            <CardDescription>
                {/* Optional description */}
            </CardDescription>
            <CardContent>
                <ul className="space-y-2">
                    {Array.isArray(notifications) && notifications.length > 0 ? (
                        [...notifications].reverse().map((notification) => (
                            <li
                                key={notification.id}
                                className={`border p-2 ${
                                    !notification.isRead ? 'text-red-600 font-bold' : 'text-black'
                                }`}
                            >
                                <button
                                    onClick={async () => {
                                        console.log('Notification Clicked:', notification);

                                        // Mark notification as read on the server
                                        await markAsReadOnServer(notification.id);

                                        // Navigate to the notification's URL
                                        if (notification.data.url) {
                                            console.log(`Navigating to: ${notification.data.url}`);
                                            navigate(notification.data.url);
                                        } else {
                                            console.log('No URL');
                                        }
                                    }}
                                    className="text-left w-full"
                                >
                                    {notification.message}
                                </button>
                            </li>
                        ))
                    ) : (
                        <li>No notifications available</li>
                    )}
                </ul>
            </CardContent>
        </Card>
    );
}
export default NotificationList